import{a as i}from"./chunk-IBNOB7HH.js";import{b as t,c as e}from"./chunk-EC436OTI.js";import{a as n}from"./chunk-4Z6EY67I.js";import{m as o}from"./chunk-HBP5N4FR.js";o();e();n();function s(r){i.dispatch(t({address:r,loginMethod:"extra"}))}export{s as a};
//# sourceMappingURL=chunk-7SGCCT6C.js.map
